import { Rule } from 'antd/lib/form';

export const maintenanceMessageFormRules = {
	startDate: (): Rule[] => [{ required: true }],
	endDate: (): Rule[] => [{ required: true }],
	description: (): Rule[] => [{ required: true, max: 511 }],
};
